import React, { createContext, useContext } from 'react';

/**
 * ModalZIndexContext
 * 
 * Simple context for tracking modal z-index levels.
 * Parent modals provide their z-index, child components (like EntityLinkedText)
 * read it to know what z-index to use when opening nested modals.
 * 
 * Usage:
 *   <ModalZIndexProvider zIndex={50}>
 *     <EntityLinkedText ... />  // Will open modals at z-index 60
 *   </ModalZIndexProvider>
 */

const ModalZIndexContext = createContext(50); // Default base z-index

export const useModalZIndex = () => {
  return useContext(ModalZIndexContext);
};

export const ModalZIndexProvider = ({ zIndex, children }) => {
  return (
    <ModalZIndexContext.Provider value={zIndex}>
      {children}
    </ModalZIndexContext.Provider>
  );
};

export default ModalZIndexContext;
